import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import DeviceMaterialsSection from './components/DeviceMaterialsSection';
import UrlAccessListSection from './components/UrlAccessListSection';

interface MonthlyTask {
  month: number;
  infoTasks: string[];
  privacyTasks: string[];
}

/** 정보관련 항목 — 클릭 시 학교 정보보안담당관 지정 상세로 이동 */
const securityOfficerDesignationTaskLabel = '정보보안담당관/담당자 지정 및 역할 공지';
const infoSecurityPlanningTaskLabel = '학교 정보보안 추진 계획 수립(교육청 정보보안 추진 계획으로 대체 가능)';

const monthlyTasks: MonthlyTask[] = [
  {
    month: 2,
    infoTasks: [ '학교 메신저 관리(쿨메신저 사용 시)', '학습지원 소프트웨어 심의(학운위)', '교내 정보기기 배부 준비(초기화 등)'],
    privacyTasks: ['개인정보 보호책임자/담당자/취급자 변경사항 사전 정비', '학교 계정 생성 및 삭제(개인정보 삭제 기안, 학급 편성 전 유출에 주의)']
  },
  {
    month: 3,
    infoTasks: [securityOfficerDesignationTaskLabel, infoSecurityPlanningTaskLabel, '정보보호(정보보안 및 개인정보보호) 교육 계획 ', '업무망·교육망·무선망 분리 운영 상태 점검', '홈페이지/주요 시스템 초기 권한 점검'],
    privacyTasks: ['개인정보 내부관리계획 개정 및 전직원 전파', '개인정보 수집·이용·제 3자 제공 동의서(필수/선택 구분) 일괄 수집 및 정비']
  },
  {
    month: 4,
    infoTasks: ['PC·노트북 보안수칙(패치/백신/화면보호기) 준수 점검', '공유폴더/불필요 프로그램/ActiveX 설정 정비'],
    privacyTasks: ['개인정보파일 일제 정비 및 표준목록 현행화', '개인정보 처리방침(홈페이지 공개 내용) 정비']
  },
  {
    month: 5,
    infoTasks: ['정보화 용역사업 보안특약·서약서·교육 이행 점검', '원격접속·서비스 허용 요청 절차 준수 점검'],
    privacyTasks: ['개인정보 보호 연간 교육 계획 수립 및 이수 증빙 수합', '위탁 업무(앨범/유지보수 등) 계약·공개·교육 여부 점검']
  },
  {
    month: 6,
    infoTasks: ['정보시스템/저장매체 반출·입 대장 점검', '통제구역 출입통제대장 및 표지·잠금장치 점검'],
    privacyTasks: ['개인정보처리시스템 권한 부여·변경·말소 내역 점검', '접속기록 자체 점검 결과 내부결재']
  },
  {
    month: 7,
    infoTasks: ['불용 PC 저장매체 삭제·파쇄 절차 이행 확인', '1학기 보안점검 결과 및 개선사항 정리'],
    privacyTasks: ['보유기간 경과 개인정보(파일) 파기 계획 수립 및 실행', '파기 완료보고 및 파기대장 정리']
  },
  {
    month: 8,
    infoTasks: ['보안 교육자료/체크리스트 2학기 버전 정비', '디지털복합기 보안 설정(기본 PW/스캔저장) 재점검'],
    privacyTasks: ['2학기 개인정보 교육/재안내 자료 보강', '수탁자 안전조치 준수 여부 점검']
  },
  {
    month: 9,
    infoTasks: ['사이버보안진단의 날 운영체계 재안내', '정보시스템 접근권한 적정성 점검(연 2회) 1차'],
    privacyTasks: ['내부관리계획 이행실태 자체 점검(연 1회 이상) 착수', '개인정보 처리방침 변경사항 발생 여부 확인']
  },
  {
    month: 10,
    infoTasks: ['정보화 용역 참여인력 보안점검 및 증빙 정리', '이메일 피싱/의심메일 대응 수칙 재교육'],
    privacyTasks: ['목적 외 이용/제3자 제공 발생 건 대장 관리 및 공개 점검', '개인영상정보(CCTV) 열람·파기 기록 관리 점검']
  },
  {
    month: 11,
    infoTasks: ['정보시스템 접근권한 적정성 점검(연 2회) 2차', '사이버침해사고 대응 연락망·신고 절차 점검'],
    privacyTasks: ['권한 관리 내역(최소 3년 보관 대상) 정리', '연말 개인정보파일 현행화 및 미비점 보완']
  },
  {
    month: 12,
    infoTasks: ['연간 정보보안 이행실적 취합 및 자체 점검', '연말 보안 미비점 시정 및 차년도 개선안 도출'],
    privacyTasks: ['개인정보 연간 이행 결과 취합 및 내부 보고', '차년도 개선 과제(계획/방침/대장) 정리']
  },
  {
    month: 1,
    infoTasks: ['정보보안담당관/담당자 인수인계 문서 정리', '대장류(시스템/저장매체/통제구역) 차년도 준비'],
    privacyTasks: ['인사발령 대비 개인정보처리시스템 권한 변경 준비', '차년도 개인정보 업무 캘린더 확정']
  }
];

const securityOfficerPdfPath =
  '/pdfs/info-chief/' + encodeURIComponent('학교 정보보안담당관 지정.pdf');

const cyberSecurityDayPdfPath =
  '/pdfs/info-chief/' + encodeURIComponent('사이버보안진단의 날 운영.pdf');

const infosecEducationPdfPath =
  '/pdfs/info-chief/' + encodeURIComponent('정보보안 교육.pdf');

const networkSecurityPdfPath =
  '/pdfs/info-chief/' + encodeURIComponent('정보통신망 보안.pdf');

const remoteAccessRequestHwpxDownloadUrl =
  'https://firebasestorage.googleapis.com/v0/b/leadlearn-ccf50.firebasestorage.app/o/' +
  encodeURIComponent('info-chief/원격 접속 허용 요청서.hwpx') +
  '?alt=media';

const serviceRequestHwpxDownloadUrl =
  'https://firebasestorage.googleapis.com/v0/b/leadlearn-ccf50.firebasestorage.app/o/' +
  encodeURIComponent('info-chief/서비스 허용 요청서.hwpx') +
  '?alt=media';

const portableStorageMediaLedgerHwpxDownloadUrl =
  'https://firebasestorage.googleapis.com/v0/b/leadlearn-ccf50.firebasestorage.app/o/' +
  encodeURIComponent('info-chief/휴대용 저장매체(전산장비포함) 반출입대장.hwpx') +
  '?alt=media';

const informationSystemSecurityPdfPath =
  '/pdfs/info-chief/' + encodeURIComponent('정보시스템 보안.pdf');

/** 정보시스템 관리대장 — 구글 스프레드시트로 복사본 생성 */
const informationSystemLedgerGoogleSheetCopyUrl =
  'https://docs.google.com/spreadsheets/d/1IgTTSsplfXsoAoKfRSk2C-CqJy2kSB9vRxjoNemHSfI/copy';

const terminalDeviceSecurityPdfPath = '/pdfs/info-chief/' + encodeURIComponent('단말기 보안.pdf');

/** 서울특별시교육청 정보보호 자료(단말기 보안 관련 HWP) */
const terminalDeviceSecuritySenHwpUrl =
  'https://www.sen.go.kr/resources/www/data/infoprotect_2_08.hwp';

const controlledAreaManagementPdfPath = '/pdfs/info-chief/' + encodeURIComponent('통제구역 관리.pdf');

const portableStorageMediaPdfPath =
  '/pdfs/info-chief/' + encodeURIComponent('휴대용 저장매체 관리.pdf');

/** 서울특별시교육청 정보보호 자료(휴대용 저장매체 관련 HWP) */
const portableStorageMediaSenHwpUrl =
  'https://www.sen.go.kr/resources/www/data/infoprotect_2_11.hwp';

const itProjectVendorManagementPdfPath =
  '/pdfs/info-chief/' + encodeURIComponent('정보화 용역사업 관리.pdf');

const cyberIncidentReportingPdfPath =
  '/pdfs/info-chief/' + encodeURIComponent('사이버침해사고 신고.pdf');

const privacyInternalManagementPlanPdfPath =
  '/pdfs/info-chief/' + encodeURIComponent('개인정보 내부 관리계획 개정 및 이행실태 점검.pdf');

/** 서울특별시교육청 개인정보보호 도움자료 — 내부관리계획 관련 서식 */
const privacyInternalManagementPlanHwpUrl =
  'https://www.sen.go.kr/resources/www/data/infoprotect_3_04.hwp';

interface RelatedSiteLink {
  title: string;
  description: string;
  href: string;
}

const relatedSiteLinks: RelatedSiteLink[] = [
  {
    title: '서울특별시교육청 정보보호 도움자료',
    description: '정보보안·개인정보보호 서식, 업무 가이드 원문 확인',
    href: 'https://www.sen.go.kr/www/education/infoprotect/infoprotect_2.jsp'
  },
  {
    title: '서울시교육청 업무 지원 서식 통합 검색',
    description: '초등·중등·비교과 업무 서식을 통합 검색하고 내려받기',
    href: 'https://sites.google.com/senedu.kr/support/home?authuser=0'
  },
  {
    title: '교육부 개인정보보호 포털',
    description: '개인정보보호 정책, 안내자료, 법령 정보',
    href: 'https://www.moe.go.kr/boardCnts/listRenew.do?boardID=349&lev=0&m=0304'
  },
  {
    title: '개인정보보호위원회',
    description: '개인정보보호법 해설, 가이드라인, 침해신고 안내',
    href: 'https://www.pipc.go.kr'
  },
  {
    title: 'KISA 보호나라',
    description: '최신 보안 권고, 침해사고 대응 자료, 교육 콘텐츠',
    href: 'https://www.boho.or.kr'
  },
  {
    title: '국가법령정보센터',
    description: '개인정보보호법·정보통신망법 등 법령 원문 조회',
    href: 'https://www.law.go.kr'
  }
];

const cyberSecurityChecklist = [
  '악성코드 백신 설치 및 실행 점검',
  '악성코드 백신 최신 보안 패치 점검',
  '운영체제/MS Office 최신 보안 패치 점검',
  '한글 프로그램 최신 보안 패치 점검',
  '로그온 패스워드 안전성 점검',
  '로그온 패스워드 사용 기간 점검',
  '화면 보호기 설정 점검',
  '사용자 공유 폴더 설정 점검',
  'USB 자동 실행 설정 점검',
  '미사용 ActiveX 프로그램 점검'
];

/** 월별 카드와 별도로, 주기(매월/상시)로 구분한 공통 업무 */
const everyMonthInfoTasks: string[] = [
  '사이버보안진단의 날 점검 실시(매월 셋째 수요일 전후·결과 기록)',
  'PC·노트북·교육용 단말 OS/백신/오피스 등 보안 패치·백신 실행 상태 점검',
  '저장매체 반출·입·통제구역 등 대장 기록 정비·누락 여부 확인'
];

const everyMonthPrivacyTasks: string[] = [
  '개인정보 열람·파기·목적 외 이용 요청 처리 기록 및 보관 기간 준수 확인'
];

const alwaysInfoTasks: string[] = [
  '업무망·교육망·무선망 분리 운영 및 원격접속·USB 통제 이상 여부 확인',
  '정보시스템·공유폴더 권한·불필요 계정·ActiveX 등 단말 보안 설정 점검',
  '학교 홈페이지 관리(내용 업데이트, 회원 승인 및 관리)'
];

const alwaysPrivacyTasks: string[] = [
  '개인정보 수집·이용 동의·위탁·제3자 제공 등 공개·계약·교육 이행 이상 여부 확인',
  '전·입사·발령 등에 따른 개인정보처리시스템 권한 부여·말소 반영 여부 점검'
];

const infoCategoryDetailGuideLinks: { to: string; label: string }[] = [
  { to: '/info-chief/cyber-security-day', label: '사이버보안진단의 날 운영' },
  { to: '/info-chief/security-officer-designation', label: '학교 정보보안담당관 지정' },
  { to: '/info-chief/info-security-education', label: '정보보안 교육' },
  { to: '/info-chief/network-security', label: '정보통신망 보안' },
  { to: '/info-chief/information-system-security', label: '정보시스템 보안' },
  { to: '/info-chief/terminal-device-security', label: '단말기 보안' },
  { to: '/info-chief/controlled-area-management', label: '통제구역 관리' },
  { to: '/info-chief/portable-storage-media', label: '휴대용 저장매체 관리' },
  { to: '/info-chief/it-project-vendor-management', label: '정보화 용역사업 관리' },
  { to: '/info-chief/cyber-incident-reporting', label: '사이버침해사고 신고' }
];

const privacyCategoryDetailGuideLinks: { to: string; label: string }[] = [
  {
    to: '/info-chief/privacy-internal-management-plan',
    label: '내부 관리계획 개정·이행실태 점검'
  }
];

const InfoChiefMainPage: React.FC = () => {
  const location = useLocation();
  const isInfoCategoryPage = location.pathname === '/info-chief/info-category';
  const isPrivacyCategoryPage = location.pathname === '/info-chief/privacy-category';
  const isPrivacyInternalManagementPlanPage =
    location.pathname === '/info-chief/privacy-internal-management-plan';
  const isCyberDetailPage = location.pathname === '/info-chief/cyber-security-day';
  const isSecurityOfficerDetailPage = location.pathname === '/info-chief/security-officer-designation';
  const isInfoSecurityEducationPage = location.pathname === '/info-chief/info-security-education';
  const isNetworkSecurityPage = location.pathname === '/info-chief/network-security';
  const isInformationSystemSecurityPage = location.pathname === '/info-chief/information-system-security';
  const isTerminalDeviceSecurityPage = location.pathname === '/info-chief/terminal-device-security';
  const isControlledAreaManagementPage = location.pathname === '/info-chief/controlled-area-management';
  const isPortableStorageMediaPage = location.pathname === '/info-chief/portable-storage-media';
  const isItProjectVendorManagementPage = location.pathname === '/info-chief/it-project-vendor-management';
  const isCyberIncidentReportingPage = location.pathname === '/info-chief/cyber-incident-reporting';
  const isDeviceMaterialsPage = location.pathname === '/info-chief/device-materials';
  const isUrlAccessListPage = location.pathname === '/info-chief/url-access-list';
  const isRelatedSitesPage = location.pathname === '/info-chief/related-sites';
  const isMonthlyFlowPage =
    !isInfoCategoryPage &&
    !isPrivacyCategoryPage &&
    !isPrivacyInternalManagementPlanPage &&
    !isCyberDetailPage &&
    !isSecurityOfficerDetailPage &&
    !isInfoSecurityEducationPage &&
    !isNetworkSecurityPage &&
    !isInformationSystemSecurityPage &&
    !isTerminalDeviceSecurityPage &&
    !isControlledAreaManagementPage &&
    !isPortableStorageMediaPage &&
    !isItProjectVendorManagementPage &&
    !isCyberIncidentReportingPage &&
    !isDeviceMaterialsPage &&
    !isUrlAccessListPage &&
    !isRelatedSitesPage;

  return (
    <main
      style={{
        width: '100%',
        maxWidth: '100%',
        margin: 0,
        padding: '24px 20px 80px',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px'
      }}
    >
      <section
        style={{
          border: '1px solid var(--Color-line-normal, #F0F0F0)',
          borderRadius: '16px',
          backgroundColor: 'white',
          padding: '24px',
          display: 'flex',
          flexDirection: 'column',
          gap: '16px'
        }}
      >
        {!isMonthlyFlowPage ? (
          <h2 style={{ margin: 0, fontSize: '24px', lineHeight: '36px', fontWeight: 600 }}>
            {isInfoCategoryPage
              ? '정보관련 업무'
              : isPrivacyCategoryPage
                ? '개인정보 관련 업무'
                : isPrivacyInternalManagementPlanPage
                  ? '내부 관리계획 개정 및 이행실태 점검'
                : isCyberDetailPage
                  ? '사이버보안진단의 날 운영 정리'
                  : isSecurityOfficerDetailPage
                    ? '학교 정보보안담당관 지정'
                    : isInfoSecurityEducationPage
                      ? '정보보안 교육'
                      : isNetworkSecurityPage
                        ? '정보통신망 보안'
                        : isInformationSystemSecurityPage
                          ? '정보시스템 보안'
                          : isTerminalDeviceSecurityPage
                            ? '단말기 보안'
                            : isControlledAreaManagementPage
                              ? '통제구역 관리'
                              : isPortableStorageMediaPage
                                ? '휴대용 저장매체 관리'
                                : isItProjectVendorManagementPage
                                  ? '정보화 용역사업 관리'
                                : isCyberIncidentReportingPage
                                  ? '사이버침해사고 신고'
                                  : isDeviceMaterialsPage
                                    ? '디지털 기기 관련'
                                    : isUrlAccessListPage
                                      ? '화이트리스트/블랙리스트'
                                    : isRelatedSitesPage
                                      ? '관련 사이트'
                                    : ''}
          </h2>
        ) : null}

        {isMonthlyFlowPage ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <div
              style={{
                borderRadius: '12px',
                border: '1px solid var(--Color-fill-brand-color, #FF6F0F)',
                backgroundColor: 'var(--Color-background-main, #F4F6FA)',
                padding: '20px',
                display: 'flex',
                flexDirection: 'column',
                gap: '12px'
              }}
            >
              <div style={{ fontSize: '17px', lineHeight: '26px', fontWeight: 700, color: 'var(--Color-text-normal, #161616)' }}>공통 업무</div>
              <p style={{ margin: 0, fontSize: '13px', lineHeight: '20px', color: 'var(--Color-text-assistive-strong, #4C4C4C)' }}>
                월별 추가 과제는 아래 월 카드와 함께 보고, 공통 업무는 주기별로 나눠서 확인하세요.{' '}
                <Link to="/info-chief/cyber-security-day" style={{ color: 'var(--Color-fill-brand-color, #FF6F0F)', fontWeight: 600 }}>
                  사이버보안진단의 날
                </Link>
                {' · '}
                <Link to="/info-chief/info-category" style={{ color: 'var(--Color-fill-brand-color, #FF6F0F)', fontWeight: 600 }}>
                  정보관련 자료
                </Link>
                {' · '}
                <Link to="/info-chief/related-sites" style={{ color: 'var(--Color-fill-brand-color, #FF6F0F)', fontWeight: 600 }}>
                  관련 사이트
                </Link>
              </p>
              <div style={{ fontSize: '15px', lineHeight: '23px', fontWeight: 700, color: 'var(--Color-text-normal, #161616)' }}>매월 반복 업무</div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '10px' }}>
                <div style={{ backgroundColor: 'white', borderRadius: '10px', padding: '12px' }}>
                  <div style={{ fontSize: '14px', fontWeight: 700, marginBottom: '8px' }}>정보관련</div>
                  <ul style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                    {everyMonthInfoTasks.map((task) => (
                      <li key={task} style={{ fontSize: '14px', lineHeight: '21px', color: 'var(--Color-text-assistive-strong, #4C4C4C)' }}>
                        {task}
                      </li>
                    ))}
                  </ul>
                </div>
                <div style={{ backgroundColor: 'white', borderRadius: '10px', padding: '12px' }}>
                  <div style={{ fontSize: '14px', fontWeight: 700, marginBottom: '8px' }}>개인정보</div>
                  <ul style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                    {everyMonthPrivacyTasks.map((task) => (
                      <li key={task} style={{ fontSize: '14px', lineHeight: '21px', color: 'var(--Color-text-assistive-strong, #4C4C4C)' }}>
                        {task}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div style={{ fontSize: '15px', lineHeight: '23px', fontWeight: 700, color: 'var(--Color-text-normal, #161616)' }}>상시 업무</div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '10px' }}>
                <div style={{ backgroundColor: 'white', borderRadius: '10px', padding: '12px' }}>
                  <div style={{ fontSize: '14px', fontWeight: 700, marginBottom: '8px' }}>정보관련</div>
                  <ul style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                    {alwaysInfoTasks.map((task) => (
                      <li key={task} style={{ fontSize: '14px', lineHeight: '21px', color: 'var(--Color-text-assistive-strong, #4C4C4C)' }}>
                        {task}
                      </li>
                    ))}
                  </ul>
                </div>
                <div style={{ backgroundColor: 'white', borderRadius: '10px', padding: '12px' }}>
                  <div style={{ fontSize: '14px', fontWeight: 700, marginBottom: '8px' }}>개인정보</div>
                  <ul style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                    {alwaysPrivacyTasks.map((task) => (
                      <li key={task} style={{ fontSize: '14px', lineHeight: '21px', color: 'var(--Color-text-assistive-strong, #4C4C4C)' }}>
                        {task}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            {monthlyTasks.map((item) => (
              <div
                key={item.month}
                style={{
                  borderRadius: '12px',
                  border: '1px solid var(--Color-line-normal, #F0F0F0)',
                  backgroundColor: 'var(--Color-background-main, #F4F6FA)',
                  padding: '20px',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '12px'
                }}
              >
                <div
                  style={{
                    alignSelf: 'flex-start',
                    textAlign: 'center',
                    borderRadius: '14px',
                    padding: '10px 18px',
                    fontSize: '22px',
                    lineHeight: '32px',
                    fontWeight: 800,
                    letterSpacing: '-0.02em',
                    color: 'white',
                    backgroundColor: 'var(--Color-fill-brand-color, #FF6F0F)',
                    boxShadow: '0 2px 8px rgba(255, 111, 15, 0.35)'
                  }}
                >
                  {item.month}월
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '10px' }}>
                  <div style={{ backgroundColor: 'white', borderRadius: '10px', padding: '12px' }}>
                    <div style={{ fontSize: '14px', fontWeight: 700, marginBottom: '8px' }}>정보관련</div>
                    <ul style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                      {item.infoTasks.map((task) => (
                        <li key={task} style={{ fontSize: '14px', lineHeight: '21px', color: 'var(--Color-text-assistive-strong, #4C4C4C)' }}>
                          {task === securityOfficerDesignationTaskLabel ? (
                            <Link
                              to="/info-chief/security-officer-designation"
                              style={{ color: 'var(--Color-fill-brand-color, #FF6F0F)', fontWeight: 600, textDecoration: 'underline' }}
                            >
                              {task}
                            </Link>
                          ) : (
                            task
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div style={{ backgroundColor: 'white', borderRadius: '10px', padding: '12px' }}>
                    <div style={{ fontSize: '14px', fontWeight: 700, marginBottom: '8px' }}>개인정보</div>
                    <ul style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                      {item.privacyTasks.map((task) => (
                        <li key={task} style={{ fontSize: '14px', lineHeight: '21px', color: 'var(--Color-text-assistive-strong, #4C4C4C)' }}>
                          {task}
                        </li>
                      ))}
                    </ul>
                  </div>

                </div>
              </div>
            ))}
          </div>
        ) : isInfoCategoryPage ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'var(--Color-background-main, #F4F6FA)', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '8px' }}>연간 핵심 일정</div>
              <ul style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>학년초: 정보보안담당관 지정, 정보보안 추진 계획 수립</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>연 1회 이상: 전 직원 정보보호 교육 및 담당자 15시간 이상 연수</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>매월: 사이버보안진단의 날 운영(세 번째 수요일)</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>상시: 망분리, 단말기 보안, 저장매체 반출입, 통제구역 관리</li>
              </ul>
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'white', padding: '20px' }}>
              <div style={{ fontSize: '20px', lineHeight: '30px', fontWeight: 700, marginBottom: '16px' }}>상세 가이드</div>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                  gap: '16px'
                }}
              >
                {infoCategoryDetailGuideLinks.map((item) => (
                  <Link
                    key={item.to}
                    to={item.to}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      gap: '10px',
                      minHeight: '100px',
                      padding: '22px 24px',
                      borderRadius: '14px',
                      border: '1px solid var(--Color-line-normal, #F0F0F0)',
                      backgroundColor: 'var(--Color-background-main, #F4F6FA)',
                      textDecoration: 'none',
                      color: 'var(--Color-text-normal, #161616)',
                      borderLeft: '4px solid var(--Color-fill-brand-color, #FF6F0F)',
                      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)'
                    }}
                  >
                    <span style={{ fontSize: '17px', lineHeight: '26px', fontWeight: 700 }}>{item.label}</span>
                    <span style={{ fontSize: '14px', lineHeight: '21px', color: 'var(--Color-text-assistive-strong, #4C4C4C)' }}>상세 페이지 →</span>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        ) : isPrivacyCategoryPage ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'var(--Color-background-main, #F4F6FA)', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '8px' }}>연간 핵심 일정</div>
              <ul style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>3~4월: 내부관리계획 개정·전파, 처리방침 변경사항 정비</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>4~5월: 개인정보파일 일제정비 및 종합지원시스템 현행화</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>상반기: 개인정보 보호 교육 계획 수립·이행·증빙 보관</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>매월: 고유식별정보 암호화 및 사이버보안진단의 날 점검</li>
              </ul>
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'white', padding: '20px' }}>
              <div style={{ fontSize: '20px', lineHeight: '30px', fontWeight: 700, marginBottom: '16px' }}>상세 가이드</div>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                  gap: '16px'
                }}
              >
                {privacyCategoryDetailGuideLinks.map((item) => (
                  <Link
                    key={item.to}
                    to={item.to}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      gap: '10px',
                      minHeight: '100px',
                      padding: '22px 24px',
                      borderRadius: '14px',
                      border: '1px solid var(--Color-line-normal, #F0F0F0)',
                      backgroundColor: 'var(--Color-background-main, #F4F6FA)',
                      textDecoration: 'none',
                      color: 'var(--Color-text-normal, #161616)',
                      borderLeft: '4px solid var(--Color-fill-brand-color, #FF6F0F)',
                      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)'
                    }}
                  >
                    <span style={{ fontSize: '17px', lineHeight: '26px', fontWeight: 700 }}>{item.label}</span>
                    <span style={{ fontSize: '14px', lineHeight: '21px', color: 'var(--Color-text-assistive-strong, #4C4C4C)' }}>상세 페이지 →</span>
                  </Link>
                ))}
              </div>
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'white', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '8px' }}>사안 발생 시 필수 조치</div>
              <ul style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>목적 외 이용/제3자 제공 시 법적근거 또는 별도 동의 확인</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>책임자 결재 후 보호조치 요청, 제공 대장 기록 및 공개사항 반영</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>위탁 계약 종료 시 개인정보 회수·파기 및 확인서 징구</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>유출 사고 시 통지·신고 절차 즉시 진행</li>
              </ul>
            </div>
          </div>
        ) : isPrivacyInternalManagementPlanPage ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <div>
              <Link
                to="/info-chief/privacy-category"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  padding: '8px 12px',
                  borderRadius: '9999px',
                  backgroundColor: 'var(--Color-background-main, #F4F6FA)',
                  color: 'var(--Color-text-normal, #161616)',
                  fontSize: '14px',
                  lineHeight: '21px',
                  fontWeight: 600,
                  textDecoration: 'none'
                }}
              >
                ← 개인정보 관련으로 돌아가기
              </Link>
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'var(--Color-background-main, #F4F6FA)', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '8px' }}>운영 개요</div>
              <ul style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>
                  근거: 개인정보 보호법 및 학교 개인정보 내부관리계획 — 연 1회 이상 이행실태 점검, 필요 시 개정·전파
                </li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>업무 시기: 통상 3~4월 개정·전파, 점검 주기에 따른 자체 점검·결재</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>범위: 개인정보 처리 현황, 제도·교육·기술·물리적 보호조치, 권한·위탁·제3자 제공 등</li>
              </ul>
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'white', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '10px' }}>서식·안내</div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '12px' }}>
                <a
                  href={privacyInternalManagementPlanHwpUrl}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '10px 16px',
                    borderRadius: '8px',
                    backgroundColor: 'var(--Color-fill-brand-color, #FF6F0F)',
                    color: 'white',
                    fontSize: '14px',
                    lineHeight: '21px',
                    fontWeight: 600,
                    textDecoration: 'none'
                  }}
                >
                  교육청 서식 다운로드 (.hwp)
                </a>
                <a
                  href={privacyInternalManagementPlanPdfPath}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '10px 16px',
                    borderRadius: '8px',
                    border: '1px solid var(--Color-line-normal, #F0F0F0)',
                    backgroundColor: 'var(--Color-background-main, #F4F6FA)',
                    color: 'var(--Color-text-normal, #161616)',
                    fontSize: '14px',
                    lineHeight: '21px',
                    fontWeight: 600,
                    textDecoration: 'none'
                  }}
                >
                  교내 PDF 보기(새 탭)
                </a>
              </div>
              <div
                style={{
                  marginBottom: '12px',
                  fontSize: '13px',
                  lineHeight: '20px',
                  color: 'var(--Color-text-assistive-strong, #4C4C4C)'
                }}
              >
                교육청 원문:{' '}
                <a href={privacyInternalManagementPlanHwpUrl} target="_blank" rel="noreferrer" style={{ color: 'var(--Color-fill-brand-color, #FF6F0F)' }}>
                  infoprotect_3_04.hwp
                </a>
                <br />
                교내 요약:{' '}
                <a href={privacyInternalManagementPlanPdfPath} target="_blank" rel="noreferrer" style={{ color: 'var(--Color-fill-brand-color, #FF6F0F)' }}>
                  개인정보 내부 관리계획 개정 및 이행실태 점검.pdf
                </a>
              </div>
              <div style={{ fontSize: '15px', lineHeight: '22px', fontWeight: 700, marginBottom: '8px' }}>PDF 미리보기</div>
              <iframe
                title="개인정보 내부 관리계획 개정 및 이행실태 점검 PDF 미리보기"
                src={privacyInternalManagementPlanPdfPath}
                style={{
                  width: '100%',
                  minHeight: '480px',
                  height: 'min(70vh, 800px)',
                  border: '1px solid var(--Color-line-normal, #F0F0F0)',
                  borderRadius: '8px',
                  backgroundColor: 'var(--Color-background-main, #F4F6FA)'
                }}
              />
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'white', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '8px' }}>점검·개정 시 확인 사항</div>
              <ul style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>내부관리계획 개정·전파 일정과 전 직원 공지·교육이 이어졌는지</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>이행실태 점검 항목별 증빙·결재·개선 과제가 정리됐는지</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>처리방침·위탁·파일 표준목록 등 연계 문서가 최신인지</li>
              </ul>
            </div>
          </div>
        ) : isDeviceMaterialsPage ? (
          <DeviceMaterialsSection />
        ) : isUrlAccessListPage ? (
          <UrlAccessListSection />
        ) : isRelatedSitesPage ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'var(--Color-background-main, #F4F6FA)', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '8px' }}>안내</div>
              <p style={{ margin: 0, fontSize: '14px', lineHeight: '21px', color: 'var(--Color-text-assistive-strong, #4C4C4C)' }}>
                정보보안·개인정보 업무 시 자주 참고하는 외부 사이트를 한곳에서 확인할 수 있도록 정리했습니다.
                학교 상황에 맞는 사이트를 추가/수정해 사용하세요.
              </p>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '12px' }}>
              {relatedSiteLinks.map((site) => (
                <a
                  key={site.href}
                  href={site.href}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    border: '1px solid var(--Color-line-normal, #F0F0F0)',
                    borderRadius: '12px',
                    backgroundColor: 'white',
                    padding: '18px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                    textDecoration: 'none',
                    color: 'var(--Color-text-normal, #161616)'
                  }}
                >
                  <div style={{ fontSize: '17px', lineHeight: '26px', fontWeight: 700 }}>{site.title}</div>
                  <div style={{ fontSize: '14px', lineHeight: '21px', color: 'var(--Color-text-assistive-strong, #4C4C4C)' }}>{site.description}</div>
                  <div style={{ fontSize: '13px', lineHeight: '20px', color: 'var(--Color-fill-brand-color, #FF6F0F)', fontWeight: 600 }}>
                    사이트 이동하기 →
                  </div>
                </a>
              ))}
            </div>
          </div>
        ) : isCyberDetailPage ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <div>
              <Link
                to="/info-chief/info-category"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  padding: '8px 12px',
                  borderRadius: '9999px',
                  backgroundColor: 'var(--Color-background-main, #F4F6FA)',
                  color: 'var(--Color-text-normal, #161616)',
                  fontSize: '14px',
                  lineHeight: '21px',
                  fontWeight: 600,
                  textDecoration: 'none'
                }}
              >
                ← 정보관련으로 돌아가기
              </Link>
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'var(--Color-background-main, #F4F6FA)', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '8px' }}>운영 개요</div>
              <ul style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>근거: 서울특별시교육청 정보보안 기본지침(2024.6.) 제10조</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>운영 시기: 매월 세 번째 수요일</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>기준 점수: 업무망(교사망) 100점, 학생망 75점 이상</li>
              </ul>
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'white', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '10px' }}>운영 안내 PDF</div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '12px' }}>
                <a
                  href={cyberSecurityDayPdfPath}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '10px 16px',
                    borderRadius: '8px',
                    border: '1px solid var(--Color-line-normal, #F0F0F0)',
                    backgroundColor: 'var(--Color-background-main, #F4F6FA)',
                    color: 'var(--Color-text-normal, #161616)',
                    fontSize: '14px',
                    lineHeight: '21px',
                    fontWeight: 600,
                    textDecoration: 'none'
                  }}
                >
                  안내 PDF 보기(새 탭)
                </a>
              </div>
              <div
                style={{
                  marginBottom: '12px',
                  fontSize: '13px',
                  lineHeight: '20px',
                  color: 'var(--Color-text-assistive-strong, #4C4C4C)'
                }}
              >
                출처:{' '}
                <a href="https://www.sen.go.kr/www/education/infoprotect/infoprotect_2.jsp" target="_blank" rel="noreferrer" style={{ color: 'var(--Color-fill-brand-color, #FF6F0F)' }}>
                  서울특별시교육청 정보보안 도움자료
                </a>
                {', '}
                정보보안 기본지침 제10조(사이버보안진단의 날 운영)
                <br />
                PDF: 교내 보관용 요약 안내(
                <a href={cyberSecurityDayPdfPath} target="_blank" rel="noreferrer" style={{ color: 'var(--Color-fill-brand-color, #FF6F0F)' }}>
                  사이버보안진단의 날 운영.pdf
                </a>
                )
              </div>
              <div style={{ fontSize: '15px', lineHeight: '22px', fontWeight: 700, marginBottom: '8px' }}>PDF 미리보기</div>
              <iframe
                title="사이버보안진단의 날 운영 PDF 미리보기"
                src={cyberSecurityDayPdfPath}
                style={{
                  width: '100%',
                  minHeight: '480px',
                  height: 'min(70vh, 800px)',
                  border: '1px solid var(--Color-line-normal, #F0F0F0)',
                  borderRadius: '8px',
                  backgroundColor: 'var(--Color-background-main, #F4F6FA)'
                }}
              />
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'white', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '8px' }}>내PC지키미 10개 점검 항목</div>
              <ol style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                {cyberSecurityChecklist.map((item) => (
                  <li key={item} style={{ fontSize: '14px', lineHeight: '21px', color: 'var(--Color-text-assistive-strong, #4C4C4C)' }}>
                    {item}
                  </li>
                ))}
              </ol>
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'white', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '8px' }}>관리자 확인 및 보고서 생성 순서</div>
              <ol style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>이클린 포털 접속 후 관할 교육지원청 선택</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>AhnLab EPP 관리자 페이지에서 에이전트 현황 확인</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>교사망/학생망 선택 후 PC 보안 점검 정보로 전환</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>보고서 생성 메뉴에서 해당 월 기준 보고서 생성</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>생성된 보고서 확인 및 결과 정리</li>
              </ol>
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'white', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '8px' }}>개인정보/게시물 정비 체크</div>
              <ul style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>주민등록번호 포함 파일은 법적 근거 확인 후 삭제 또는 암호화</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>개인정보 포함 파일 및 중요자료는 개별 문서 암호화 적용</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>홈페이지 게시자료의 개인정보/비공개 자료 노출 여부 점검</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>공개기한 경과 게시물 및 불필요 게시글 정비</li>
              </ul>
            </div>
          </div>
        ) : isInfoSecurityEducationPage ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <div>
              <Link
                to="/info-chief/info-category"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  padding: '8px 12px',
                  borderRadius: '9999px',
                  backgroundColor: 'var(--Color-background-main, #F4F6FA)',
                  color: 'var(--Color-text-normal, #161616)',
                  fontSize: '14px',
                  lineHeight: '21px',
                  fontWeight: 600,
                  textDecoration: 'none'
                }}
              >
                ← 정보관련으로 돌아가기
              </Link>
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'var(--Color-background-main, #F4F6FA)', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '8px' }}>운영 개요</div>
              <ul style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>근거: 서울특별시교육청 정보보안 기본지침(2024.6.) 제9조(정보보안 교육)</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>업무 시기: 상시(연 1회 이상)</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>대상: 전 직원 정보보호(정보보안 및 개인정보 보호) 교육</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>분임담당 등: 정보보안 기본지침에 따른 연간 연수·교육 시간 이수</li>
              </ul>
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'white', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '10px' }}>
                서식: 정보보안 교육(계획·교육 자료·결과 보고 기안문 예시)
              </div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '12px' }}>
                <a
                  href="https://www.sen.go.kr/resources/www/data/infoprotect_2_04.hwp"
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '10px 16px',
                    borderRadius: '8px',
                    backgroundColor: 'var(--Color-fill-brand-color, #FF6F0F)',
                    color: 'white',
                    fontSize: '14px',
                    lineHeight: '21px',
                    fontWeight: 600,
                    textDecoration: 'none'
                  }}
                >
                  서식·기안문 다운로드 (.hwp)
                </a>
                <a
                  href={infosecEducationPdfPath}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '10px 16px',
                    borderRadius: '8px',
                    border: '1px solid var(--Color-line-normal, #F0F0F0)',
                    backgroundColor: 'var(--Color-background-main, #F4F6FA)',
                    color: 'var(--Color-text-normal, #161616)',
                    fontSize: '14px',
                    lineHeight: '21px',
                    fontWeight: 600,
                    textDecoration: 'none'
                  }}
                >
                  안내 PDF 보기(새 탭)
                </a>
              </div>
              <div
                style={{
                  marginBottom: '12px',
                  fontSize: '13px',
                  lineHeight: '20px',
                  color: 'var(--Color-text-assistive-strong, #4C4C4C)'
                }}
              >
                출처:{' '}
                <a href="https://www.sen.go.kr/www/education/infoprotect/infoprotect_2.jsp" target="_blank" rel="noreferrer" style={{ color: 'var(--Color-fill-brand-color, #FF6F0F)' }}>
                  서울특별시교육청 정보보안 도움자료
                </a>
                {', '}
                정보보안 기본지침 제9조(정보보안 교육)
                <br />
                PDF: 교내 보관용 요약 안내(
                <a href={infosecEducationPdfPath} target="_blank" rel="noreferrer" style={{ color: 'var(--Color-fill-brand-color, #FF6F0F)' }}>
                  정보보안 교육.pdf
                </a>
                )
              </div>
              <div style={{ fontSize: '15px', lineHeight: '22px', fontWeight: 700, marginBottom: '8px' }}>PDF 미리보기</div>
              <iframe
                title="정보보안 교육 PDF 미리보기"
                src={infosecEducationPdfPath}
                style={{
                  width: '100%',
                  minHeight: '480px',
                  height: 'min(70vh, 800px)',
                  border: '1px solid var(--Color-line-normal, #F0F0F0)',
                  borderRadius: '8px',
                  backgroundColor: 'var(--Color-background-main, #F4F6FA)'
                }}
              />
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'white', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '8px' }}>교육 및 보고 절차</div>
              <ol style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>학교 연간 일정에 맞추어 교육 계획 수립 및 내부기안(예시 서식 참고)</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>교육 자료를 검토해 정보보안·개인정보 보호가 함께 다뤄지도록 한 뒤 교육 실시</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>결과 보고 기안(예시) 작성, 교육대장·참석·이수 확인 등 증빙을 학교 기준에 따라 보관</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>분임담당 등 대상별 연수·이수 시간은 기본지침 및 교육청 안내에 따름</li>
              </ol>
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'white', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '8px' }}>교육 운영 시 확인 사항</div>
              <ul style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>연 1회 이상 전 직원 교육 이행 여부</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>망분리, 단말기·저장매체 보안, 개인정보 취급 유의 등 주제 포함 여부</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>실시 일자·방법·참석(이수) 범위가 문서·기록으로 남는지</li>
              </ul>
            </div>
          </div>
        ) : isNetworkSecurityPage ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <div>
              <Link
                to="/info-chief/info-category"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  padding: '8px 12px',
                  borderRadius: '9999px',
                  backgroundColor: 'var(--Color-background-main, #F4F6FA)',
                  color: 'var(--Color-text-normal, #161616)',
                  fontSize: '14px',
                  lineHeight: '21px',
                  fontWeight: 600,
                  textDecoration: 'none'
                }}
              >
                ← 정보관련으로 돌아가기
              </Link>
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'var(--Color-background-main, #F4F6FA)', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '8px' }}>운영 개요</div>
              <ul style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>
                  근거: 서울특별시교육청 정보보안 기본지침(2024.6.) 제40조(내부망·인터넷망 분리), 제43조(무선랜 보안), 제47조(인터넷 사용제한), 제69조(정보통신망 현황자료 관리) 등
                </li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>업무 시기: 상시(원격접속·서비스 허용·망 변경 시 등 사안 발생 시)</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>범위: 업무망·교육망 분리, 원격접속·인터넷·무선 서비스 허용, 정보통신망 현황 파악·관리</li>
              </ul>
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'white', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '10px' }}>
                서식: 원격접속·서비스 허용 요청 및 정보통신망 관련 서식(예시)
              </div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '12px' }}>
                <a
                  href="https://www.sen.go.kr/resources/www/data/infoprotect_2_07.hwp"
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '10px 16px',
                    borderRadius: '8px',
                    backgroundColor: 'var(--Color-fill-brand-color, #FF6F0F)',
                    color: 'white',
                    fontSize: '14px',
                    lineHeight: '21px',
                    fontWeight: 600,
                    textDecoration: 'none'
                  }}
                >
                  서식·절차 다운로드 (.hwp)
                </a>
                <a
                  href={networkSecurityPdfPath}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '10px 16px',
                    borderRadius: '8px',
                    border: '1px solid var(--Color-line-normal, #F0F0F0)',
                    backgroundColor: 'var(--Color-background-main, #F4F6FA)',
                    color: 'var(--Color-text-normal, #161616)',
                    fontSize: '14px',
                    lineHeight: '21px',
                    fontWeight: 600,
                    textDecoration: 'none'
                  }}
                >
                  안내 PDF 보기(새 탭)
                </a>
                <a
                  href={remoteAccessRequestHwpxDownloadUrl}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '10px 16px',
                    borderRadius: '8px',
                    border: '1px solid var(--Color-line-normal, #F0F0F0)',
                    backgroundColor: 'var(--Color-background-main, #F4F6FA)',
                    color: 'var(--Color-text-normal, #161616)',
                    fontSize: '14px',
                    lineHeight: '21px',
                    fontWeight: 600,
                    textDecoration: 'none'
                  }}
                >
                  원격 접속 허용 요청서(.hwpx)
                </a>
                <a
                  href={serviceRequestHwpxDownloadUrl}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '10px 16px',
                    borderRadius: '8px',
                    border: '1px solid var(--Color-line-normal, #F0F0F0)',
                    backgroundColor: 'var(--Color-background-main, #F4F6FA)',
                    color: 'var(--Color-text-normal, #161616)',
                    fontSize: '14px',
                    lineHeight: '21px',
                    fontWeight: 600,
                    textDecoration: 'none'
                  }}
                >
                  서비스 허용 요청서(.hwpx)
                </a>
              </div>
              <div
                style={{
                  marginBottom: '12px',
                  fontSize: '13px',
                  lineHeight: '20px',
                  color: 'var(--Color-text-assistive-strong, #4C4C4C)'
                }}
              >
                출처:{' '}
                <a href="https://www.sen.go.kr/www/education/infoprotect/infoprotect_2.jsp" target="_blank" rel="noreferrer" style={{ color: 'var(--Color-fill-brand-color, #FF6F0F)' }}>
                  서울특별시교육청 정보보안 도움자료
                </a>
                {' '}(목록 4. 정보통신망 보안)
                <br />
                PDF: 교내 보관용 요약 안내(
                <a href={networkSecurityPdfPath} target="_blank" rel="noreferrer" style={{ color: 'var(--Color-fill-brand-color, #FF6F0F)' }}>
                  정보통신망 보안.pdf
                </a>
                )
              </div>
              <div style={{ fontSize: '15px', lineHeight: '22px', fontWeight: 700, marginBottom: '8px' }}>PDF 미리보기</div>
              <iframe
                title="정보통신망 보안 PDF 미리보기"
                src={networkSecurityPdfPath}
                style={{
                  width: '100%',
                  minHeight: '480px',
                  height: 'min(70vh, 800px)',
                  border: '1px solid var(--Color-line-normal, #F0F0F0)',
                  borderRadius: '8px',
                  backgroundColor: 'var(--Color-background-main, #F4F6FA)'
                }}
              />
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'white', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '8px' }}>원격·서비스 허용 및 망 운영 절차</div>
              <ol style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>내부망·인터넷망 분리 원칙과 무선망·인터넷 이용 제한을 학교 실정에 맞게 안내</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>원격접속 또는 인터넷·서비스 허용이 필요한 경우 기본지침에 따른 요청서·절차로 승인 후 개통</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>정보통신망·시스템 현황자료를 정비·유지하여 변경·폐지 시 반영</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>허용·변경 내역과 결재·보관 체계를 학교 규정에 맞게 유지</li>
              </ol>
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'white', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '8px' }}>운영 시 확인 사항</div>
              <ul style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>교육망·업무망 혼용·무단 무선 AP 등 망분리 위반 요소가 없는지</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>원격접속·클라우드·메신저 등 서비스 허용 전 보안 검토·결재가 있었는지</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>정보시스템 관리대장·망 현황과 실제 운용이 일치하는지</li>
              </ul>
            </div>
          </div>
        ) : isInformationSystemSecurityPage ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <div>
              <Link
                to="/info-chief/info-category"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  padding: '8px 12px',
                  borderRadius: '9999px',
                  backgroundColor: 'var(--Color-background-main, #F4F6FA)',
                  color: 'var(--Color-text-normal, #161616)',
                  fontSize: '14px',
                  lineHeight: '21px',
                  fontWeight: 600,
                  textDecoration: 'none'
                }}
              >
                ← 정보관련으로 돌아가기
              </Link>
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'var(--Color-background-main, #F4F6FA)', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '8px' }}>운영 개요</div>
              <ul style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>
                  근거: 서울특별시교육청 정보보안 기본지침(2024.6.) 제48조(정보시스템 보안책임), 제49조(정보시스템 유지보수), 제59조(저장매체 불용처리), 제76조(휴대용 저장매체 보안) 등
                </li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>업무 시기: 상시(시스템 신규·변경·폐지, 저장매체 반출입·불용 시 등)</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>범위: 정보시스템 관리대장, 휴대용 저장매체 반·출입, 전자정보 저장매체 파쇄 요청 등</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>
                  정보시스템 관리대장(구글 스프레드시트 양식):{' '}
                  <a
                    href={informationSystemLedgerGoogleSheetCopyUrl}
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: 'var(--Color-fill-brand-color, #FF6F0F)' }}
                  >
                    복사본 만들기(새 탭)
                  </a>
                </li>
              </ul>
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'white', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '10px' }}>
                서식: 정보시스템 관리·저장매체 반출입·불용(파쇄) 관련 서식(예시)
              </div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '12px' }}>
                <a
                  href="https://www.sen.go.kr/resources/www/data/infoprotect_2_07.hwp"
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '10px 16px',
                    borderRadius: '8px',
                    backgroundColor: 'var(--Color-fill-brand-color, #FF6F0F)',
                    color: 'white',
                    fontSize: '14px',
                    lineHeight: '21px',
                    fontWeight: 600,
                    textDecoration: 'none'
                  }}
                >
                  서식·절차 다운로드 (.hwp)
                </a>
                <a
                  href={informationSystemSecurityPdfPath}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '10px 16px',
                    borderRadius: '8px',
                    border: '1px solid var(--Color-line-normal, #F0F0F0)',
                    backgroundColor: 'var(--Color-background-main, #F4F6FA)',
                    color: 'var(--Color-text-normal, #161616)',
                    fontSize: '14px',
                    lineHeight: '21px',
                    fontWeight: 600,
                    textDecoration: 'none'
                  }}
                >
                  안내 PDF 보기(새 탭)
                </a>
                <a
                  href={informationSystemLedgerGoogleSheetCopyUrl}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '10px 16px',
                    borderRadius: '8px',
                    border: '1px solid var(--Color-line-normal, #F0F0F0)',
                    backgroundColor: 'var(--Color-background-main, #F4F6FA)',
                    color: 'var(--Color-text-normal, #161616)',
                    fontSize: '14px',
                    lineHeight: '21px',
                    fontWeight: 600,
                    textDecoration: 'none'
                  }}
                >
                  관리대장 양식(구글 시트 복사)
                </a>
                <a
                  href={portableStorageMediaLedgerHwpxDownloadUrl}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '10px 16px',
                    borderRadius: '8px',
                    border: '1px solid var(--Color-line-normal, #F0F0F0)',
                    backgroundColor: 'var(--Color-background-main, #F4F6FA)',
                    color: 'var(--Color-text-normal, #161616)',
                    fontSize: '14px',
                    lineHeight: '21px',
                    fontWeight: 600,
                    textDecoration: 'none'
                  }}
                >
                  반출입대장(.hwpx) 다운로드
                </a>
              </div>
              <div
                style={{
                  marginBottom: '12px',
                  fontSize: '13px',
                  lineHeight: '20px',
                  color: 'var(--Color-text-assistive-strong, #4C4C4C)'
                }}
              >
                출처:{' '}
                <a href="https://www.sen.go.kr/www/education/infoprotect/infoprotect_2.jsp" target="_blank" rel="noreferrer" style={{ color: 'var(--Color-fill-brand-color, #FF6F0F)' }}>
                  서울특별시교육청 정보보안 도움자료
                </a>
                {' '}(목록 5. 정보시스템 보안)
                <br />
                PDF: 교내 보관용 요약 안내(
                <a href={informationSystemSecurityPdfPath} target="_blank" rel="noreferrer" style={{ color: 'var(--Color-fill-brand-color, #FF6F0F)' }}>
                  정보시스템 보안.pdf
                </a>
                )
                <br />
                반출입대장(HWPX):{' '}
                <a href={portableStorageMediaLedgerHwpxDownloadUrl} target="_blank" rel="noreferrer" style={{ color: 'var(--Color-fill-brand-color, #FF6F0F)' }}>
                  휴대용 저장매체(전산장비포함) 반출입대장.hwpx
                </a>
                <br />
                관리대장(구글 스프레드시트):{' '}
                <a
                  href={informationSystemLedgerGoogleSheetCopyUrl}
                  target="_blank"
                  rel="noreferrer"
                  style={{ color: 'var(--Color-fill-brand-color, #FF6F0F)' }}
                >
                  양식 복사본 만들기
                </a>
              </div>
              <div style={{ fontSize: '15px', lineHeight: '22px', fontWeight: 700, marginBottom: '8px' }}>PDF 미리보기</div>
              <iframe
                title="정보시스템 보안 PDF 미리보기"
                src={informationSystemSecurityPdfPath}
                style={{
                  width: '100%',
                  minHeight: '480px',
                  height: 'min(70vh, 800px)',
                  border: '1px solid var(--Color-line-normal, #F0F0F0)',
                  borderRadius: '8px',
                  backgroundColor: 'var(--Color-background-main, #F4F6FA)'
                }}
              />
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'white', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '8px' }}>대장·유지보수·불용 처리 절차</div>
              <ol style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>정보시스템 관리대장에 자산·담당·변경 이력이 누락 없이 기록되도록 정비</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>유지보수·용역 접근 시 보안특약·교육·접근 통제 등 제49조에 따른 조치 이행</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>휴대용 저장매체 반·출입 시 대장에 기록하고, 불용·파쇄는 절차·기안문(예시)에 따라 처리</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>시스템 폐지·매체 불용 시 개인정보·중요자료 잔존 여부 확인 후 파쇄·삭제 등 조치</li>
              </ol>
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'white', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '8px' }}>운영 시 확인 사항</div>
              <ul style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>관리대장의 시스템·저장매체 현황과 실물·실제 연결 정보가 일치하는지</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>반·출입·불용·파쇄 건마다 결재·증빙·대장 기록이 남는지</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>용역·외부 인력이 관리하는 장비·접근에 보안 통제가 적용되는지</li>
              </ul>
            </div>
          </div>
        ) : isTerminalDeviceSecurityPage ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <div>
              <Link
                to="/info-chief/info-category"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  padding: '8px 12px',
                  borderRadius: '9999px',
                  backgroundColor: 'var(--Color-background-main, #F4F6FA)',
                  color: 'var(--Color-text-normal, #161616)',
                  fontSize: '14px',
                  lineHeight: '21px',
                  fontWeight: 600,
                  textDecoration: 'none'
                }}
              >
                ← 정보관련으로 돌아가기
              </Link>
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'var(--Color-background-main, #F4F6FA)', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '8px' }}>운영 개요</div>
              <ul style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>
                  근거: 서울특별시교육청 정보보안 기본지침 — PC·노트북 등 단말기 비밀번호·패치·백신·화면보호기·공유폴더 등 단말 보안
                </li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>업무 시기: 상시(사이버보안진단의 날, 학기초 점검, 장비 교체 시 등)</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>범위: 업무·교육용 PC, ActiveX·미디어 차단, 계정·권한 등</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>
                  이클린 포털(백신·PC 보안 현황):{' '}
                  <a href="https://sen.go.kr/eclean/" target="_blank" rel="noreferrer" style={{ color: 'var(--Color-fill-brand-color, #FF6F0F)' }}>
                    https://sen.go.kr/eclean/
                  </a>
                </li>
              </ul>
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'white', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '10px' }}>서식·안내: 단말기 보안</div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '12px' }}>
                <a
                  href={terminalDeviceSecuritySenHwpUrl}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '10px 16px',
                    borderRadius: '8px',
                    backgroundColor: 'var(--Color-fill-brand-color, #FF6F0F)',
                    color: 'white',
                    fontSize: '14px',
                    lineHeight: '21px',
                    fontWeight: 600,
                    textDecoration: 'none'
                  }}
                >
                  서식 다운로드 (.hwp)
                </a>
                <a
                  href="https://sen.go.kr/eclean/"
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '10px 16px',
                    borderRadius: '8px',
                    border: '1px solid var(--Color-line-normal, #F0F0F0)',
                    backgroundColor: 'var(--Color-background-main, #F4F6FA)',
                    color: 'var(--Color-text-normal, #161616)',
                    fontSize: '14px',
                    lineHeight: '21px',
                    fontWeight: 600,
                    textDecoration: 'none'
                  }}
                >
                  이클린 포털 열기(새 탭)
                </a>
                <a
                  href={terminalDeviceSecurityPdfPath}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '10px 16px',
                    borderRadius: '8px',
                    border: '1px solid var(--Color-line-normal, #F0F0F0)',
                    backgroundColor: 'var(--Color-background-main, #F4F6FA)',
                    color: 'var(--Color-text-normal, #161616)',
                    fontSize: '14px',
                    lineHeight: '21px',
                    fontWeight: 600,
                    textDecoration: 'none'
                  }}
                >
                  안내 PDF 보기(새 탭)
                </a>
              </div>
              <div
                style={{
                  marginBottom: '12px',
                  fontSize: '13px',
                  lineHeight: '20px',
                  color: 'var(--Color-text-assistive-strong, #4C4C4C)'
                }}
              >
                출처:{' '}
                <a href="https://www.sen.go.kr/www/education/infoprotect/infoprotect_2.jsp" target="_blank" rel="noreferrer" style={{ color: 'var(--Color-fill-brand-color, #FF6F0F)' }}>
                  서울특별시교육청 정보보안 도움자료
                </a>
                {', '}
                정보보안 기본지침(단말기 보안)
                <br />
                PDF: 교내·업무용 요약(
                <a href={terminalDeviceSecurityPdfPath} target="_blank" rel="noreferrer" style={{ color: 'var(--Color-fill-brand-color, #FF6F0F)' }}>
                  단말기 보안.pdf
                </a>
                )
              </div>
              <div style={{ fontSize: '15px', lineHeight: '22px', fontWeight: 700, marginBottom: '8px' }}>PDF 미리보기</div>
              <iframe
                title="단말기 보안 PDF 미리보기"
                src={terminalDeviceSecurityPdfPath}
                style={{
                  width: '100%',
                  minHeight: '480px',
                  height: 'min(70vh, 800px)',
                  border: '1px solid var(--Color-line-normal, #F0F0F0)',
                  borderRadius: '8px',
                  backgroundColor: 'var(--Color-background-main, #F4F6FA)'
                }}
              />
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'white', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '8px' }}>운영 시 확인 사항</div>
              <ul style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>백신 실행·패치·화면보호기·계정 잠금이 정책에 맞게 적용됐는지</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>공유폴더·불필요 ActiveX·USB 정책 등 단말 설정이 점검·교육과 맞는지</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>사이버보안진단의 날 점검 결과와 실제 단말 상태가 일치하는지</li>
              </ul>
            </div>
          </div>
        ) : isControlledAreaManagementPage ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <div>
              <Link
                to="/info-chief/info-category"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  padding: '8px 12px',
                  borderRadius: '9999px',
                  backgroundColor: 'var(--Color-background-main, #F4F6FA)',
                  color: 'var(--Color-text-normal, #161616)',
                  fontSize: '14px',
                  lineHeight: '21px',
                  fontWeight: 600,
                  textDecoration: 'none'
                }}
              >
                ← 정보관련으로 돌아가기
              </Link>
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'var(--Color-background-main, #F4F6FA)', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '8px' }}>운영 개요</div>
              <ul style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>
                  근거: 서울특별시교육청 정보보안 기본지침 — 통제구역 지정·출입 통제·대장 관리 등
                </li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>업무 시기: 상시(서버실·통제구역 출입, 시설 변경 시)</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>범위: 출입통제대장, 표지·잠금장치, 열쇠·카드 관리 등</li>
              </ul>
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'white', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '10px' }}>
                서식: 통제구역 출입통제대장 등(예시)
              </div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '12px' }}>
                <a
                  href="https://www.sen.go.kr/resources/www/data/infoprotect_2_09.hwp"
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '10px 16px',
                    borderRadius: '8px',
                    backgroundColor: 'var(--Color-fill-brand-color, #FF6F0F)',
                    color: 'white',
                    fontSize: '14px',
                    lineHeight: '21px',
                    fontWeight: 600,
                    textDecoration: 'none'
                  }}
                >
                  서식 다운로드 (.hwp)
                </a>
                <a
                  href={controlledAreaManagementPdfPath}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '10px 16px',
                    borderRadius: '8px',
                    border: '1px solid var(--Color-line-normal, #F0F0F0)',
                    backgroundColor: 'var(--Color-background-main, #F4F6FA)',
                    color: 'var(--Color-text-normal, #161616)',
                    fontSize: '14px',
                    lineHeight: '21px',
                    fontWeight: 600,
                    textDecoration: 'none'
                  }}
                >
                  안내 PDF 보기(새 탭)
                </a>
              </div>
              <div
                style={{
                  marginBottom: '12px',
                  fontSize: '13px',
                  lineHeight: '20px',
                  color: 'var(--Color-text-assistive-strong, #4C4C4C)'
                }}
              >
                출처:{' '}
                <a href="https://www.sen.go.kr/www/education/infoprotect/infoprotect_2.jsp" target="_blank" rel="noreferrer" style={{ color: 'var(--Color-fill-brand-color, #FF6F0F)' }}>
                  서울특별시교육청 정보보안 도움자료
                </a>
                {' '}(목록 7. 통제구역 관리)
                <br />
                HWP:{' '}
                <a
                  href="https://www.sen.go.kr/resources/www/data/infoprotect_2_09.hwp"
                  target="_blank"
                  rel="noreferrer"
                  style={{ color: 'var(--Color-fill-brand-color, #FF6F0F)' }}
                >
                  infoprotect_2_09.hwp
                </a>
                <br />
                PDF: 교내 보관용 요약 안내(
                <a href={controlledAreaManagementPdfPath} target="_blank" rel="noreferrer" style={{ color: 'var(--Color-fill-brand-color, #FF6F0F)' }}>
                  통제구역 관리.pdf
                </a>
                )
              </div>
              <div style={{ fontSize: '15px', lineHeight: '22px', fontWeight: 700, marginBottom: '8px' }}>PDF 미리보기</div>
              <iframe
                title="통제구역 관리 PDF 미리보기"
                src={controlledAreaManagementPdfPath}
                style={{
                  width: '100%',
                  minHeight: '480px',
                  height: 'min(70vh, 800px)',
                  border: '1px solid var(--Color-line-normal, #F0F0F0)',
                  borderRadius: '8px',
                  backgroundColor: 'var(--Color-background-main, #F4F6FA)'
                }}
              />
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'white', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '8px' }}>운영 시 확인 사항</div>
              <ul style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>통제구역 표지·잠금·출입 통제가 실제와 일치하는지</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>출입통제대장에 방문·작업·용역 인력 기록이 누락 없는지</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>열쇠·카드·생체 등 출입 수단 관리, 분실 시 조치가 있는지</li>
              </ul>
            </div>
          </div>
        ) : isPortableStorageMediaPage ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <div>
              <Link
                to="/info-chief/info-category"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  padding: '8px 12px',
                  borderRadius: '9999px',
                  backgroundColor: 'var(--Color-background-main, #F4F6FA)',
                  color: 'var(--Color-text-normal, #161616)',
                  fontSize: '14px',
                  lineHeight: '21px',
                  fontWeight: 600,
                  textDecoration: 'none'
                }}
              >
                ← 정보관련으로 돌아가기
              </Link>
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'var(--Color-background-main, #F4F6FA)', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '8px' }}>운영 개요</div>
              <ul style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>
                  근거: 서울특별시교육청 정보보안 기본지침 — 휴대용 저장매체 반·출입, 불용·파쇄, 기록 보관 등(정보시스템 보안과 연계)
                </li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>업무 시기: 상시(USB·외장하드 등 반출입, 인수인계, 파쇄 요청 시)</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>범위: 휴대용 저장매체 반·출입 대장, 불용 처리, 직원·학생 매체 취급 유의 등</li>
              </ul>
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'white', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '10px' }}>서식·안내: 휴대용 저장매체 관리</div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '12px' }}>
                <a
                  href={portableStorageMediaSenHwpUrl}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '10px 16px',
                    borderRadius: '8px',
                    backgroundColor: 'var(--Color-fill-brand-color, #FF6F0F)',
                    color: 'white',
                    fontSize: '14px',
                    lineHeight: '21px',
                    fontWeight: 600,
                    textDecoration: 'none'
                  }}
                >
                  서식 다운로드 (.hwp)
                </a>
                <a
                  href={portableStorageMediaPdfPath}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '10px 16px',
                    borderRadius: '8px',
                    border: '1px solid var(--Color-line-normal, #F0F0F0)',
                    backgroundColor: 'var(--Color-background-main, #F4F6FA)',
                    color: 'var(--Color-text-normal, #161616)',
                    fontSize: '14px',
                    lineHeight: '21px',
                    fontWeight: 600,
                    textDecoration: 'none'
                  }}
                >
                  안내 PDF 보기(새 탭)
                </a>
              </div>
              <div
                style={{
                  marginBottom: '12px',
                  fontSize: '13px',
                  lineHeight: '20px',
                  color: 'var(--Color-text-assistive-strong, #4C4C4C)'
                }}
              >
                출처:{' '}
                <a href="https://www.sen.go.kr/www/education/infoprotect/infoprotect_2.jsp" target="_blank" rel="noreferrer" style={{ color: 'var(--Color-fill-brand-color, #FF6F0F)' }}>
                  서울특별시교육청 정보보안 도움자료
                </a>
                {', '}
                정보보안 기본지침(휴대용 저장매체 관리)
                <br />
                PDF: 교내·업무용 요약(
                <a href={portableStorageMediaPdfPath} target="_blank" rel="noreferrer" style={{ color: 'var(--Color-fill-brand-color, #FF6F0F)' }}>
                  휴대용 저장매체 관리.pdf
                </a>
                )
                <br />
                시스템·대장 연계는{' '}
                <Link to="/info-chief/information-system-security" style={{ color: 'var(--Color-fill-brand-color, #FF6F0F)', fontWeight: 600 }}>
                  정보시스템 보안(상세)
                </Link>
                와 함께 보면 됩니다.
              </div>
              <div style={{ fontSize: '15px', lineHeight: '22px', fontWeight: 700, marginBottom: '8px' }}>PDF 미리보기</div>
              <iframe
                title="휴대용 저장매체 관리 PDF 미리보기"
                src={portableStorageMediaPdfPath}
                style={{
                  width: '100%',
                  minHeight: '480px',
                  height: 'min(70vh, 800px)',
                  border: '1px solid var(--Color-line-normal, #F0F0F0)',
                  borderRadius: '8px',
                  backgroundColor: 'var(--Color-background-main, #F4F6FA)'
                }}
              />
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'white', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '8px' }}>운영 시 확인 사항</div>
              <ul style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>반·출입 시 대장에 일시·목적·반환 여부가 기록되는지</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>분실·불용 시 파쇄·삭제·회수 절차와 증빙이 남는지</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>개인정보·중요자료가 담긴 매체는 별도 통제·암호화 원칙을 따르는지</li>
              </ul>
            </div>
          </div>
        ) : isItProjectVendorManagementPage ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <div>
              <Link
                to="/info-chief/info-category"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  padding: '8px 12px',
                  borderRadius: '9999px',
                  backgroundColor: 'var(--Color-background-main, #F4F6FA)',
                  color: 'var(--Color-text-normal, #161616)',
                  fontSize: '14px',
                  lineHeight: '21px',
                  fontWeight: 600,
                  textDecoration: 'none'
                }}
              >
                ← 정보관련으로 돌아가기
              </Link>
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'var(--Color-background-main, #F4F6FA)', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '8px' }}>운영 개요</div>
              <ul style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>
                  근거: 서울특별시교육청 정보보안 기본지침(2024.6.) 제13조(제안요청서 기재사항), 제25~30조(계약 및 사업 수행), 제49조(정보시스템 유지보수) 등
                </li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>업무 시기: 사안 발생 시(용역·위탁·유지보수 계약·입회·자료 인수인계 등)</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>범위: 보안특약·서약서, 용역 인력 보안교육·점검, 개인정보 위탁 특약, 인수인계·저장매체 반출입 등</li>
              </ul>
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'white', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '10px' }}>
                서식: 정보화 용역사업 보안특약·교육·인수인계 등(예시)
              </div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '12px' }}>
                <a
                  href="https://www.sen.go.kr/resources/www/data/infoprotect_2_15.hwp"
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '10px 16px',
                    borderRadius: '8px',
                    backgroundColor: 'var(--Color-fill-brand-color, #FF6F0F)',
                    color: 'white',
                    fontSize: '14px',
                    lineHeight: '21px',
                    fontWeight: 600,
                    textDecoration: 'none'
                  }}
                >
                  서식·절차 다운로드 (.hwp)
                </a>
                <a
                  href={itProjectVendorManagementPdfPath}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '10px 16px',
                    borderRadius: '8px',
                    border: '1px solid var(--Color-line-normal, #F0F0F0)',
                    backgroundColor: 'var(--Color-background-main, #F4F6FA)',
                    color: 'var(--Color-text-normal, #161616)',
                    fontSize: '14px',
                    lineHeight: '21px',
                    fontWeight: 600,
                    textDecoration: 'none'
                  }}
                >
                  안내 PDF 보기(새 탭)
                </a>
              </div>
              <div
                style={{
                  marginBottom: '12px',
                  fontSize: '13px',
                  lineHeight: '20px',
                  color: 'var(--Color-text-assistive-strong, #4C4C4C)'
                }}
              >
                출처:{' '}
                <a href="https://www.sen.go.kr/www/education/infoprotect/infoprotect_2.jsp" target="_blank" rel="noreferrer" style={{ color: 'var(--Color-fill-brand-color, #FF6F0F)' }}>
                  서울특별시교육청 정보보안 도움자료
                </a>
                {' '}(목록 10. 정보화 용역사업 관리)
                <br />
                PDF: 교내 보관용 요약 안내(
                <a href={itProjectVendorManagementPdfPath} target="_blank" rel="noreferrer" style={{ color: 'var(--Color-fill-brand-color, #FF6F0F)' }}>
                  정보화 용역사업 관리.pdf
                </a>
                )
              </div>
              <div style={{ fontSize: '15px', lineHeight: '22px', fontWeight: 700, marginBottom: '8px' }}>PDF 미리보기</div>
              <iframe
                title="정보화 용역사업 관리 PDF 미리보기"
                src={itProjectVendorManagementPdfPath}
                style={{
                  width: '100%',
                  minHeight: '480px',
                  height: 'min(70vh, 800px)',
                  border: '1px solid var(--Color-line-normal, #F0F0F0)',
                  borderRadius: '8px',
                  backgroundColor: 'var(--Color-background-main, #F4F6FA)'
                }}
              />
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'white', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '8px' }}>용역·계약 대응 절차</div>
              <ol style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>제안요청서·계약서에 보안특약·개인정보 처리 위탁 특약 등 필수 기재 여부 확인</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>용역 인력에 대해 보안서약·교육·점검을 실시하고 기록·증빙 보관</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>작업·유지보수 시 접근 통제, 자료 인수인계 대장·저장매체 반출입 절차 준수</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>사업 종료 시 자료 반납·파기·권한 회수 등 종료 절차 이행</li>
              </ol>
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'white', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '8px' }}>운영 시 확인 사항</div>
              <ul style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>계약·특약에 따라 보안교육·점검·서약이 실제로 이행됐는지</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>개인정보·중요자료가 용역사에 불필요하게 제공되지 않았는지</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>인수인계·반출입·파기 기록이 사업 단계별로 남는지</li>
              </ul>
            </div>
          </div>
        ) : isCyberIncidentReportingPage ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <div>
              <Link
                to="/info-chief/info-category"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  padding: '8px 12px',
                  borderRadius: '9999px',
                  backgroundColor: 'var(--Color-background-main, #F4F6FA)',
                  color: 'var(--Color-text-normal, #161616)',
                  fontSize: '14px',
                  lineHeight: '21px',
                  fontWeight: 600,
                  textDecoration: 'none'
                }}
              >
                ← 정보관련으로 돌아가기
              </Link>
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'var(--Color-background-main, #F4F6FA)', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '8px' }}>운영 개요</div>
              <ul style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>
                  근거: 서울특별시교육청 정보보안 기본지침(2024.6.) 제98조(보안관제센터 설치·운영), 제107조(사이버공격으로 인한 사고) 등
                </li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>업무 시기: 사안 발생 시(침해 징후·사고 확인 즉시)</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>범위: 신고·보고, 증거 보전, 확산 방지, 복구·재발 방지 등</li>
              </ul>
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'white', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '10px' }}>
                서식: 사이버침해사고 신고서(예시)
              </div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '12px' }}>
                <a
                  href="https://www.sen.go.kr/resources/www/data/infoprotect_2_13.hwp"
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '10px 16px',
                    borderRadius: '8px',
                    backgroundColor: 'var(--Color-fill-brand-color, #FF6F0F)',
                    color: 'white',
                    fontSize: '14px',
                    lineHeight: '21px',
                    fontWeight: 600,
                    textDecoration: 'none'
                  }}
                >
                  서식 다운로드 (.hwp)
                </a>
                <a
                  href={cyberIncidentReportingPdfPath}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '10px 16px',
                    borderRadius: '8px',
                    border: '1px solid var(--Color-line-normal, #F0F0F0)',
                    backgroundColor: 'var(--Color-background-main, #F4F6FA)',
                    color: 'var(--Color-text-normal, #161616)',
                    fontSize: '14px',
                    lineHeight: '21px',
                    fontWeight: 600,
                    textDecoration: 'none'
                  }}
                >
                  안내 PDF 보기(새 탭)
                </a>
              </div>
              <div
                style={{
                  marginBottom: '12px',
                  fontSize: '13px',
                  lineHeight: '20px',
                  color: 'var(--Color-text-assistive-strong, #4C4C4C)'
                }}
              >
                출처:{' '}
                <a href="https://www.sen.go.kr/www/education/infoprotect/infoprotect_2.jsp" target="_blank" rel="noreferrer" style={{ color: 'var(--Color-fill-brand-color, #FF6F0F)' }}>
                  서울특별시교육청 정보보안 도움자료
                </a>
                {' '}(목록 11. 사이버침해사고 신고)
                <br />
                PDF: 교내 보관용 요약 안내(
                <a href={cyberIncidentReportingPdfPath} target="_blank" rel="noreferrer" style={{ color: 'var(--Color-fill-brand-color, #FF6F0F)' }}>
                  사이버침해사고 신고.pdf
                </a>
                )
              </div>
              <div style={{ fontSize: '15px', lineHeight: '22px', fontWeight: 700, marginBottom: '8px' }}>PDF 미리보기</div>
              <iframe
                title="사이버침해사고 신고 PDF 미리보기"
                src={cyberIncidentReportingPdfPath}
                style={{
                  width: '100%',
                  minHeight: '480px',
                  height: 'min(70vh, 800px)',
                  border: '1px solid var(--Color-line-normal, #F0F0F0)',
                  borderRadius: '8px',
                  backgroundColor: 'var(--Color-background-main, #F4F6FA)'
                }}
              />
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'white', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '8px' }}>대응·신고 절차(권장)</div>
              <ol style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>침해 징후 확인 시 즉시 격리·차단 등 확산 방지 조치를 우선하고, 로그·증거가 훼손되지 않도록 보전</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>학교장·정보보안 담당자 보고 후, 기본지침·교육청·유관기관 안내에 따라 신고서 작성·제출</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>사고 유형·피해 범위·조치 내역을 기록하고, 이후 복구·패치·교육 등 재발 방지 계획 수립</li>
              </ol>
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'white', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '8px' }}>운영 시 확인 사항</div>
              <ul style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>연락망·보고 체계가 학교 운영 규정에 반영돼 있는지</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>사고 발생 시 신고·보고 시한·경로를 숙지했는지</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>유사 사고 시 참고할 수 있도록 훈련·점검 기록이 있는지</li>
              </ul>
            </div>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <div>
              <Link
                to="/info-chief/info-category"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  padding: '8px 12px',
                  borderRadius: '9999px',
                  backgroundColor: 'var(--Color-background-main, #F4F6FA)',
                  color: 'var(--Color-text-normal, #161616)',
                  fontSize: '14px',
                  lineHeight: '21px',
                  fontWeight: 600,
                  textDecoration: 'none'
                }}
              >
                ← 정보관련으로 돌아가기
              </Link>
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'var(--Color-background-main, #F4F6FA)', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '8px' }}>운영 개요</div>
              <ul style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>근거: 서울특별시교육청 정보보안 기본지침(2024.6.) 제5조(정보보안담당관 운영)</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>업무 시기: 정보보안담당관 변경 시(인사이동 시)</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>임명권자: 학교장(교감 또는 정보보안 업무 담당 부장 중 임명)</li>
              </ul>
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'white', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '10px' }}>서식: 정보보안담당관 임명 및 관리 체계 수립 기안문(예시)</div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '12px' }}>
                <a
                  href="https://www.sen.go.kr/resources/www/data/infoprotect_2_03.hwp"
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '10px 16px',
                    borderRadius: '8px',
                    backgroundColor: 'var(--Color-fill-brand-color, #FF6F0F)',
                    color: 'white',
                    fontSize: '14px',
                    lineHeight: '21px',
                    fontWeight: 600,
                    textDecoration: 'none'
                  }}
                >
                  기안문 다운로드 (.hwp)
                </a>
                <a
                  href={securityOfficerPdfPath}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '10px 16px',
                    borderRadius: '8px',
                    border: '1px solid var(--Color-line-normal, #F0F0F0)',
                    backgroundColor: 'var(--Color-background-main, #F4F6FA)',
                    color: 'var(--Color-text-normal, #161616)',
                    fontSize: '14px',
                    lineHeight: '21px',
                    fontWeight: 600,
                    textDecoration: 'none'
                  }}
                >
                  안내 PDF 보기(새 탭)
                </a>
              </div>
              <div
                style={{
                  marginBottom: '12px',
                  fontSize: '13px',
                  lineHeight: '20px',
                  color: 'var(--Color-text-assistive-strong, #4C4C4C)'
                }}
              >
                출처:{' '}
                <a href="https://www.sen.go.kr/www/education/infoprotect/infoprotect_2.jsp" target="_blank" rel="noreferrer" style={{ color: 'var(--Color-fill-brand-color, #FF6F0F)' }}>
                  서울특별시교육청 정보보안 도움자료
                </a>
                {', '}
                정보보안 기본지침 제5조(정보보안담당관 운영)
                <br />
                PDF: 교내 보관용 요약 안내(
                <a href={securityOfficerPdfPath} target="_blank" rel="noreferrer" style={{ color: 'var(--Color-fill-brand-color, #FF6F0F)' }}>
                  학교 정보보안담당관 지정.pdf
                </a>
                )
              </div>
              <div style={{ fontSize: '15px', lineHeight: '22px', fontWeight: 700, marginBottom: '8px' }}>PDF 미리보기</div>
              <iframe
                title="학교 정보보안담당관 지정 PDF 미리보기"
                src={securityOfficerPdfPath}
                style={{
                  width: '100%',
                  minHeight: '480px',
                  height: 'min(70vh, 800px)',
                  border: '1px solid var(--Color-line-normal, #F0F0F0)',
                  borderRadius: '8px',
                  backgroundColor: 'var(--Color-background-main, #F4F6FA)'
                }}
              />
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'white', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '8px' }}>지정 및 관리 절차</div>
              <ol style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>인사이동 여부 확인 후 정보보안담당관 변경 필요성 검토</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>정보보안담당관 임명 및 관리체계 수립 내부기안 작성</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>학교장 결재 완료 후 지정 문서 자체 보관</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>정보보안담당자/분임담당관 역할 분장 및 업무 공지</li>
              </ol>
            </div>

            <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'white', padding: '18px' }}>
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '8px' }}>정보보안담당관 기본 활동</div>
              <ul style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>정보통신실/정보통신망 현황자료 보안관리 총괄</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>정보보안교육 총괄 및 사이버보안진단의 날 시행</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>기관 내 정보보안업무 및 분임담당관 업무 감독</li>
                <li style={{ fontSize: '14px', lineHeight: '21px' }}>기타 정보보안 관련 사항 총괄 관리</li>
              </ul>
            </div>
          </div>
        )}
      </section>
    </main>
  );
};

export default InfoChiefMainPage;
